import React from 'react';
import cn from 'classnames';

import { Layout } from '@bit/bit.rendering.constants.layouts';
import { Button } from '../../../../button/text-button';
import { Icon } from '../../../../icon';

import { SplitterProps } from '../../splitter-props';
import Splitter from '../../splitter';

import styles from './collapsible-splitter.module.scss';

export function CollapsibleSplitter(props: SplitterProps) {
	const toggleCollapse = () => {
		const { layout, onLayoutChange } = props;
		if (!onLayoutChange) return;

		if (layout.includes('first') || layout.includes('last')) {
			return onLayoutChange(undefined);
		}

		if (layout.includes(Layout.column)) {
			return onLayoutChange(Layout.top);
		}

		if (layout.includes(Layout.row)) {
			return onLayoutChange(Layout.right);
		}
	};

	const { layout } = props;

	const togglerIcon = layoutToIcon(layout);

	return (
		<Splitter {...props} className={cn(styles.collapsibleSplitter, props.className)}>
			<span className={cn('column-handle', styles.handle)}>─</span>
			<span className={cn('row-handle', styles.handle)}>|</span>

			<span className={styles.actionBox}>
				{togglerIcon && (
					<Button style={{ outline: 'none' }} onClick={toggleCollapse}>
						<Icon of={togglerIcon} />
					</Button>
				)}
			</span>
		</Splitter>
	);
}

//"good enough for now" ~ Uri Kutner, Nov 2019
function layoutToIcon(layout: Layout) {
	if (layout.includes('column') && layout.includes('first')) {
		return 'full-arrow-head-up';
	}
	if (layout.includes('column') && !layout.includes('first')) {
		return 'full-arrow-head-down';
	}
	if (layout.includes('row') && layout.includes('last')) {
		return 'full-arrow-head-right';
	}
	if (layout.includes('row') && !layout.includes('last')) {
		return 'full-arrow-head-left';
	}
}
